// libs
import { useCallback } from 'react';

import {
  onTableViewAction,
  TableViewActionTypes,
} from '@/modules/corporate/modules/database/views/TableView/hooks/useTableViewActions/actions';
// types
import { SelectFieldOptionsType } from '@/types/schema';

interface Params {
  documentId: string;
  fieldId: string;
  multiple: boolean;
  onAction: onTableViewAction;
  toggleIsEditing: () => void;
}

const useSelectEditableCell = (params: Params) => {
  const { fieldId, multiple, onAction, documentId, toggleIsEditing } = params;

  const onChange = useCallback(
    (nextValue: string) => {
      onAction({
        type: TableViewActionTypes.UpdateCellValue,
        payload: { documentId, fieldId, data: { value: nextValue } },
      });

      // if not multi-select close on selection
      if (!multiple) {
        toggleIsEditing();
      }
    },
    [onAction, documentId, fieldId, multiple, toggleIsEditing],
  );

  const onAddOption = useCallback(
    (option: SelectFieldOptionsType) => {
      onAction({
        type: TableViewActionTypes.AddSelectOption,
        payload: { fieldId, option },
      });
    },
    [fieldId, onAction],
  );

  const onClose = useCallback(
    (_event: React.ChangeEvent<{}>, reason: string) => {
      if (reason === 'escape') {
        toggleIsEditing();
      }
    },
    [toggleIsEditing],
  );

  return { multiple, onAddOption, onChange, onClose };
};

export default useSelectEditableCell;
